import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators';
import Store from '@/store/index';

@Module({
  dynamic: true,
  store: Store,
  name: 'doctor',
  namespaced: true,
})
export default class Doctor extends VuexModule {
  cachedUsers: { [key: string]: any } = {};

  @Mutation
  flushCachedById(id: string) {
    const changed = { ...this.cachedUsers }
    delete changed[id];
    this.cachedUsers = changed;
  }

  @Mutation
  flushAll() {
    this.cachedUsers = {};
  }

  @Mutation
  cacheOne(doctor: any) {
    this.cachedUsers = {
      ...this.cachedUsers,
      [doctor.$id]: doctor,
    };
  }

  get items() {
    return this.cachedUsers;
  }
}
